import api from './axios';

export const userAPI = {
  /**
   * Получить данные текущего пользователя
   * @returns {Promise} Данные пользователя
   */
  getProfile: async () => {
    const response = await api.get('/api/v1/user');
    return response.data;
  },

  /**
   * Обновить данные пользователя
   * @param {Object} data - Данные для обновления
   * @returns {Promise} Обновлённые данные пользователя
   */
  updateProfile: async (data) => {
    const response = await api.put('/api/v1/user', data);
    return response.data;
  },

  /**
   * Получить информацию о лимитах портов пользователя
   * @returns {Promise} Информация о лимитах
   */
  getLimits: async () => {
    const response = await api.get('/api/v1/user/limits');
    return response.data;
  },

  /**
   * Получить статистику трафика пользователя
   * @param {Object} params - Опциональные параметры (startDate, endDate)
   * @returns {Promise} Статистика трафика
   */
  getStats: async (params = {}) => {
    const response = await api.get('/api/v1/users/stats', { params });
    return response.data;
  }
};
